// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__tB50q","validationTips":"StatementDescriptor_validationTips___dclh"};